import { RouteConfig } from "vue-router";
import Prediction from "@/views/prediction/Prediction.vue";
import Recommendation from "@/views/recommendation/Recommedation.vue";
import Balance from "@/views/balance/Balance.vue";
import Login from "@/views/login/Login.vue";
import Help from "@/views/help/Help.vue";
import predictionHistory from "@/views/predictionHistory/PredictionHistory.vue";
import RecommendationHistory from "@/views/recommendationHistory/RecommendationHistory.vue";
import BalanceHistory from "@/views/balanceHistory/BalanceHistory.vue";
import { ROUTES } from "./pwa";

const routes: Array<RouteConfig> = [
  {
    path: ROUTES.dashboard,
    redirect: "/prediction",
  },
  {
    path: ROUTES.prediction,
    name: "prediction",
    component: Prediction,
  },
  {
    path: ROUTES.predictionHistory,
    name: "predictionHistory",
    component: predictionHistory,
  },
  {
    path: ROUTES.recommendation,
    name: "recommendation",
    component: Recommendation,
  },
  {
    path: ROUTES.recommendationHistory,
    name: "recommendationHistory",
    component: RecommendationHistory,
  },
  {
    path: ROUTES.balance,
    name: "balance",
    component: Balance,
  },
  {
    path: ROUTES.balanceHistory,
    name: "balanceHistory",
    component: BalanceHistory,
  },
  {
    path: "/help",
    name: "help",
    component: Help,
  },
  {
    path: ROUTES.login,
    name: "login",
    component: Login,
  },
  {
    path: "*",
    redirect: "/",
  },
];

export default routes;
